import styled from 'styled-components';

export const ContainerFundoComVerdeEscuro = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  z-index: 0;
  background-color: ${({ theme }) => theme.colors.accent.accent[3]};
`;
